import { useState, useEffect } from 'react';
import {
  getHeadersUnwrapped,
  searchSerialNumbers,
  searchSerialNumbersAdmin,
  useUserContext,
  SerialNumberOption
} from '../common';
import { compose as lcompose } from 'lodash/fp';

export const useSerialNumberSearch = ({
  forRegistrantsNCoordinators,
}: {
  forRegistrantsNCoordinators: boolean;
}) => {
  const { user } = useUserContext();

  const [serialNumberInput, setSerialNumberInput] = useState('');
  const [options, setOptions] = useState<SerialNumberOption[]>([]);

  useEffect(() => {
    lcompose(
      forRegistrantsNCoordinators
        ? searchSerialNumbers
        : searchSerialNumbersAdmin,
      getHeadersUnwrapped
    )(user)(serialNumberInput).then(setOptions);
  }, [forRegistrantsNCoordinators, serialNumberInput, user]);

  return { serialNumbers: options, serialNumberInput, setSerialNumberInput };
};
